
import React from 'react';
import { NikoFacilityOrderNewFlowMissingInventoryCountConfirmModalTemplate } from 'themes/application/niko-facility-order-inventory/components';
import { observer } from 'mobx-react';
import { setCurrentView } from 'core/utils';
import { NikoFacilityOrderNewFlowMissingInventoryCountConfirmModalStore } from 'application/niko-facility-order-inventory/stores';

@setCurrentView((rootStore, componentProps) => new NikoFacilityOrderNewFlowMissingInventoryCountConfirmModalStore(rootStore, componentProps), 'nikoFacilityOrderNewFlowMissingInventoryCountConfirmModalStore')
@observer
class NikoFacilityOrderNewFlowMissingInventoryCountConfirmModal extends React.Component {
    render() {
        return <NikoFacilityOrderNewFlowMissingInventoryCountConfirmModalTemplate {...this.props} />
    }
}

export default NikoFacilityOrderNewFlowMissingInventoryCountConfirmModal;
